import { styled } from '@mui/material';
import { paymentModeType } from '../types';

function PaymentModeLabel(props: { paymentMode: paymentModeType }): JSX.Element {
    switch (props.paymentMode) {
        case 'comptant-cheque':
            return (
                <p>
                    par chèque bancaire à l’ordre de l'ÉSAJ (à envoyer à l'ÉSAJ - 13 rue de
                    Santeuil, 75005 PARIS)
                </p>
            );
        case 'comptant-virement':
            return <p>par virement bancaire</p>;
        case 'echelonne-cheque':
            return (
                <p>
                    par chèque bancaire à l'ordre de l'ÉSAJ (trois chèques à envoyer à l'ÉSAJ - 13
                    rue de Santeuil, 75005 PARIS ; ils devront être datés{' '}
                    <EmphasizedText>du jour de leur signature</EmphasizedText>, avec les échéances
                    écrites au dos de chacun)
                </p>
            );
        case 'echelonne-virement':
            return (
                <p>
                    par virement bancaire <EmphasizedText>avant</EmphasizedText> les dates indiquées
                    ci-dessus
                </p>
            );
    }
}

const EmphasizedText = styled('span')(({ theme }) => ({
    textDecoration: 'underline',
    fontWeight: 'bold',
}));

export { PaymentModeLabel };
